export default "__VITE_PUBLIC_ASSET__185fcfb7__"